import posthog from 'posthog-js';

const GIFTING_HOSTS = new Set(['trigrly.com', 'www.trigrly.com']);
const isGiftingDomain =
  typeof window !== 'undefined' && GIFTING_HOSTS.has(window.location.hostname);

const key = isGiftingDomain
  ? process.env.REACT_APP_POSTHOG_KEY_TRIGRLY
  : process.env.REACT_APP_POSTHOG_KEY;

posthog.init(key, {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  autocapture: true,
  capture_pageview: true,
  capture_pageleave: true,
  session_recording: {
    recordCrossOriginIframes: true,
  },
});

export default posthog;
